import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Seo from "@/components/Seo";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { StatsBand } from "@/components/StatsBand";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { Commodities } from "@/components/Commodities";
import { Network } from "@/components/Network";
import { WhyAgaman } from "@/components/WhyAgaman";
import { TrackShipment } from "@/components/TrackShipment";
import { Marquee } from "@/components/Marquee";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#0D1117] text-slate-100">
      <Seo
        title="Agaman Freight — Pan-India Trucking, ODC & Warehousing"
        siteName="Agaman Freight"
        image="/og-image.png"
        description="Full truck load, over-dimensional cargo, heavy trailers and warehousing across India — GPS-tracked and delivered with on-time discipline. Get a freight quote today."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Agaman Freight",
          email: "contact@agaman.co",
          description:
            "Pan-India trucking and warehousing company moving freight by truck and trailer across India.",
        }}
      />
      <Nav />
      <main>
        <Hero />
        <StatsBand />
        <Manifesto />
        <Services />
        <Commodities />
        <Network />
        <WhyAgaman />
        <TrackShipment />
        <Marquee />
        <QuoteForm />
      </main>
      <Footer />
      <WhatsAppFloat />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
